var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-image-uploader"},[_c('input',{ref:"imagefile",staticClass:"hidden",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.selectPhoto}})])
}
var staticRenderFns = []

export { render, staticRenderFns }